
import { Row } from "antd"
import { GlobalUtil } from "../../../utils/GlobalText"
import { StyleUtils } from "../../../utils/Style"
import { formatStr } from "../../../utils/Utils"
import { ServerIncomeInfo, ServerTotalRevenue } from "../../../data/common"
import { IncomeLabeView } from "./IncomeLabeView"
import { IncomeLabeView2 } from "./IncomeLabeView2"
import { UserInfoManager } from "../../../utils/UserInfoManager"


interface PcProps {
    data?: ServerTotalRevenue | null | undefined
    incomeData?: ServerIncomeInfo[]
}
export const MobileCardView = (props: PcProps) => {
    const { data, incomeData } = props
    return (
        <div className="mob-card-view">
            <Row >
                <IncomeLabeView icon={StyleUtils.ICON_INCOME_ALL} title={GlobalUtil.t("income.today")} value={data?.todayEstRevenue !== undefined ? data.todayEstRevenue.toLocaleString(undefined, { minimumFractionDigits: 6 }).replace(/\.?0+$/, '') : '0'} list={incomeData} />
            </Row>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap:".625rem" }}>
                <Row>
                  {(UserInfoManager.getShowCurrency() === "NEPTUNE" || UserInfoManager.getShowCurrency() === "NEPTUNE_OLD") ? (
                    <IncomeLabeView2
                      icon={StyleUtils.ICON_INCOME_BALANCE}
                      title1={formatStr(GlobalUtil.t("income.balance"), UserInfoManager.getShowCurrency())}
                      value1={
                        data?.balance !== undefined
                          ? data.balance.toLocaleString(undefined, { minimumFractionDigits: 6 }).replace(/\.?0+$/, '')
                          : '0'
                      }
                      title2={GlobalUtil.t("income.availableBalance")}
                      value2={
                        data?.availableBalance !== undefined
                          ? data.availableBalance.toLocaleString(undefined, { minimumFractionDigits: 6 }).replace(/\.?0+$/, '')
                          : '0'
                      }
                      title3={formatStr(
                        GlobalUtil.t("income.availablePopover"),
                        data?.totalLockIncome !== undefined
                          ? data.totalLockIncome.toLocaleString(undefined, { minimumFractionDigits: 6 }).replace(/\.?0+$/, '')
                          : '0'
                      )}
                    />
                  ) : (
                    <IncomeLabeView
                      icon={StyleUtils.ICON_INCOME_BALANCE}
                      title={formatStr(GlobalUtil.t("income.balance"), UserInfoManager.getShowCurrency())}
                      value={
                        data?.balance !== undefined
                          ? data.balance.toLocaleString(undefined, { minimumFractionDigits: 6 }).replace(/\.?0+$/, '')
                          : '0'
                      }
                    />
                  )}
                </Row>
                <Row>
                  {(UserInfoManager.getShowCurrency() === "NEPTUNE" || UserInfoManager.getShowCurrency() === "NEPTUNE_OLD") ? (
                    <IncomeLabeView2
                      icon={StyleUtils.ICON_INCOME_ALL}
                      title1={formatStr(GlobalUtil.t("income.allIncome"), UserInfoManager.getShowCurrency())}
                      value1={
                        data?.totalIncome !== undefined
                          ? data.totalIncome.toLocaleString(undefined, { minimumFractionDigits: 6 }).replace(/\.?0+$/, '')
                          : '0'
                      }
                      title2={GlobalUtil.t("income.allLockAmount")}
                      value2={
                        data?.totalLockIncome !== undefined
                          ? data.totalLockIncome.toLocaleString(undefined, { minimumFractionDigits: 6 }).replace(/\.?0+$/, '')
                          : '0'
                      }
                      titleColor='#899199'
                      title3={GlobalUtil.t("income.lockAmountTip")}
                    />
                  ) : (
                      <IncomeLabeView icon={StyleUtils.ICON_INCOME_ALL} title={formatStr(GlobalUtil.t("income.allIncome"), UserInfoManager.getShowCurrency())} value={data?.totalIncome !== undefined ? data.totalIncome.toLocaleString(undefined, { minimumFractionDigits: 6 }).replace(/\.?0+$/, '') : '0'}/>
                  )}
                </Row>
                <Row style={{ flex: "1 1 50%" }}>
                    <IncomeLabeView icon={StyleUtils.ICON_INCOME_PAYOUT} title={formatStr(GlobalUtil.t("income.allPayout"),  UserInfoManager.getShowCurrency())} value={data?.totalPayout !== undefined ? data.totalPayout.toLocaleString(undefined, { minimumFractionDigits: 6 }).replace(/\.?0+$/, '') : '0'} />
                </Row>
                <Row style={{ flex: "1 1 50%" }}>
                    <IncomeLabeView icon={StyleUtils.ICON_INCOME_yesterday} title={formatStr(GlobalUtil.t("income.yesterday"), UserInfoManager.getShowCurrency())} value={
                                                            data?.yesterdayRevenue === 0 && new Date().getUTCHours() < 5 ?
                                                            GlobalUtil.t("income.settlementInProgress") :
                                                            (data?.yesterdayRevenue !== undefined ? data.yesterdayRevenue.toLocaleString(undefined, { minimumFractionDigits: 6 }).replace(/\.?0+$/, '') : '0')
                                                        } />
                </Row>
            </div>
        </div>
    )
}